import React from 'react';
import moment from 'moment';
import { Tooltip } from '@material-ui/core';
import { Position } from 'react-flow-renderer';

const RelativeDate = ({
  datetime
}: { datetime?: string }) => (
  datetime ? (
    <Tooltip placement="top" title={moment(datetime).format('llll')}>
      <span>{moment(datetime).fromNow()}</span>
    </Tooltip>
  ) : <span>&mdash;</span>
);

export default RelativeDate;
